import * as React from 'react';
import { Hr } from '@grandvisionhq/elements';
import { useProductDetailSlots, ProductDetailTitleView, StickyAside, ProductDetailUsps, ProductDetailDisclaimer, ProductDetailDrawerStack } from '@grandvisionhq/fun-products';
import { ReviewSnippet } from '@grandvisionhq/reviews';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/state';
import '@swc/helpers';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/inventory';
import '@grandvisionhq/utils';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-monetate';
import { ProductDetailReviewsDrawerContainer } from '../Components/ProductDetailReviews/ProductDetailReviewsDrawerContainer.js';
import { ProductImageGalleryContainer } from '../Components/ProductImageGallery/ProductImageGalleryContainer.js';
import { ProductLabelTag } from '../Components/ProductLabelTag/ProductLabelTag.js';
import '@grandvisionhq/carts-v2';
import { Description } from './Components/Description/Description.js';
import { PackageSelector } from './Components/PackageSelector/PackageSelector.js';
import { SolutionsPriceSection } from './Components/SolutionsPriceSection/SolutionsPriceSection.js';
import { SolutionsQuantityAndStock } from './Components/SolutionsQuantityAndStock/SolutionsQuantityAndStock.js';
import { SolutionsStickyCTA } from './Components/SolutionsStickyCTA/SolutionsStickyCTA.js';
import { SolutionsSubscriptionPurchase } from './Components/SolutionsSubscriptionPurchase/SolutionsSubscriptionPurchase.js';
import { SolutionsSpecification } from './Components/SolutionsSpecification/SolutionsSpecification.js';

const Solutions = ({ addToCartRef , ctaButton , brandLink , isSmallScreen , showStickyButton , variant , variants , brandModel , selectedQuantity , onQuantityChange , isOrderable ,  })=>{
    var ref;
    const { Slots  } = useProductDetailSlots();
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main product-detail-solutions"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, /*#__PURE__*/ React.createElement(ProductImageGalleryContainer, null)), isSmallScreen && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: `${variant.modelName} ${brandModel}`,
        subtitle: variant.brand,
        href: brandLink,
        sku: variant.sku
    }), /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: variant.sku
    })), /*#__PURE__*/ React.createElement("section", {
        className: "product-detail__aside",
        "aria-label": `${variant.modelName} ${variant.modelName}`
    }, /*#__PURE__*/ React.createElement(StickyAside, {
        bottomBoundary: ".product-detail",
        isEnabled: !isSmallScreen
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mobile-hidden"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: `${variant.modelName} ${brandModel}`,
        subtitle: variant.brand,
        href: brandLink,
        sku: variant.sku
    }), !isSmallScreen && /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: variant.sku
    })), ((ref = variant.tag) === null || ref === void 0 ? void 0 : ref.value) && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__product-tag"
    }, /*#__PURE__*/ React.createElement(ProductLabelTag, null)), !!variant.price && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SolutionsPriceSection, {
        className: "product-detail__specification-prices"
    }), Slots.AfterPrice ? /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__after-price-slot"
    }, /*#__PURE__*/ React.createElement(Slots.AfterPrice, null)) : null), /*#__PURE__*/ React.createElement(PackageSelector, {
        variants: variants,
        className: "product-detail-solutions__package-selector"
    }), /*#__PURE__*/ React.createElement(SolutionsSubscriptionPurchase, {
        className: "product-detail-solutions__subscription"
    }), /*#__PURE__*/ React.createElement(SolutionsQuantityAndStock, {
        onQuantityChange: onQuantityChange,
        selectedQuantity: selectedQuantity,
        isOrderable: isOrderable
    }), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details",
        ref: addToCartRef
    }, Slots.DynamicDeliveryIndicator ? /*#__PURE__*/ React.createElement(Slots.DynamicDeliveryIndicator, {
        deliveryItems: [
            {
                sku: variant.sku,
                quantity: selectedQuantity
            }
        ],
        isExcludedFromCheckout: variant.excludedFromCheckout
    }) : null, ctaButton, Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null), isSmallScreen && showStickyButton && /*#__PURE__*/ React.createElement(SolutionsStickyCTA, {
        ctaButton: ctaButton
    }), /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), /*#__PURE__*/ React.createElement(ProductDetailUsps, {
        className: "product-detail__usps"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__description"
    }, /*#__PURE__*/ React.createElement(Description, null)), /*#__PURE__*/ React.createElement(ProductDetailDisclaimer, {
        className: "product-detail__disclaimer product-detail-solutions__disclaimer"
    }), /*#__PURE__*/ React.createElement(ProductDetailDrawerStack, {
        className: "product-detail__drawer-stack"
    }, /*#__PURE__*/ React.createElement(SolutionsSpecification, null), /*#__PURE__*/ React.createElement(ProductDetailReviewsDrawerContainer, null)));
};

export { Solutions, Solutions as default };
//# sourceMappingURL=Solutions.js.map
